import * as React from "react"
import { type VTableSectionProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import { Tfoot } from "@digits-shared/DesignSystem/Tables/tableStyles"
import { flexRender } from "@tanstack/react-table"

/*
  COMPONENTS
*/
export const VTableFooter = <TData extends object>({ ref, table }: VTableSectionProps<TData>) => {
  const footerGroups = table
    .getFooterGroups()
    ?.filter((g) => g.headers.some((f) => !!f.column.columnDef.footer))

  if (!footerGroups.length) return null

  return (
    <Tfoot ref={ref}>
      {footerGroups.map((group) => (
        <tr key={group.id}>
          {group.headers.map((footer) => {
            const key = footer.id
            return (
              <td key={key} data-header={key} colSpan={footer.colSpan}>
                {flexRender(footer.column.columnDef.footer, footer.getContext())}
              </td>
            )
          })}
        </tr>
      ))}
    </Tfoot>
  )
}
